import { EThemeType } from "redux/reducers";

interface Iprop {
  theme?: EThemeType | undefined;
  signup?:boolean;
  filtergptModelLanguage?: boolean;
}
export const AccountArrowIcon=({theme,signup}:Iprop)=>{
  const getStrokeColor = () => {
    if (theme === "light" && signup) return "#A09FA2";
    if (theme === "dark" && signup) return "#737377";
    return theme === "light" ? "#2A2831" : "white";
  };
    return(
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M8 10L12 14L16 10" stroke={getStrokeColor()} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    );
}

export const CompatibleModIcon = ({filtergptModelLanguage}: Iprop) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
  <g clipPath="url(#clip0_808_3655)">
    <path d="M3.22015 8.77959C3.51312 9.07256 3.9889 9.07256 4.28187 8.77959L7.28187 5.77959C7.4975 5.56397 7.56078 5.24287 7.44359 4.96162C7.3264 4.68037 7.05453 4.49756 6.74984 4.49756L0.74984 4.4999C0.447496 4.4999 0.173277 4.68272 0.0560899 4.96397C-0.0610976 5.24522 0.00452741 5.56631 0.217809 5.78193L3.21781 8.78193L3.22015 8.77959Z" fill={filtergptModelLanguage? "#94A3B8" : "#737373"}/>
  </g>
  <defs>
    <clipPath id="clip0_808_3655">
      <rect width="7.5" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>
  )
}

export const SelectedLanguageCross = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
      <path d="M8.02949 4.02969C8.32246 3.73672 8.32246 3.26094 8.02949 2.96797C7.73652 2.675 7.26074 2.675 6.96777 2.96797L4.4998 5.43828L2.02949 2.97032C1.73652 2.67735 1.26074 2.67735 0.967773 2.97032C0.674805 3.26328 0.674805 3.73907 0.967773 4.03203L3.43809 6.5L0.970117 8.97031C0.677148 9.26328 0.677148 9.73907 0.970117 10.032C1.26309 10.325 1.73887 10.325 2.03184 10.032L4.4998 7.56172L6.97012 10.0297C7.26309 10.3227 7.73887 10.3227 8.03184 10.0297C8.32481 9.73672 8.32481 9.26094 8.03184 8.96797L5.56152 6.5L8.02949 4.02969Z" fill="white"/>
    </svg> 
  )
}